import React from "react";
import { DetialComponent } from "./style";
import { Row, Col } from "react-bootstrap";
import Button from "components/button";
import NumberFormat from "components/numberFormat";
const Detial = ({ item, next, prev, showPic }) => {
  return (
    <DetialComponent>
      <Row>
        <Col sm={12} md={4} lg={3}>
          <aside className="side">
            <div className="image">
              <img src={`./images/${showPic}.jpg`} alt="product" />
            </div>
            <div className="content">
              <div className="labels">
                <span>{item?.title}</span>
              </div>
              <div className="price-area">
                <div className="grey-item">{item?.price_note}</div>
                <div className="amount">
                  مبلغ قابل پرداخت: <NumberFormat value={item?.price} />
                </div>
              </div>
            </div>
          </aside>
        </Col>
        <Col sm={12} md={8} lg={9}>
          <section className="info">
            {item.item.specifications.map((specification) => (
              <div className="item" key={specification.key}>
                <span className="title">{specification.key}</span>
                <span className="value">{specification.value}</span>
              </div>
            ))}
            <div className="notice">
            لازم به یادآوری است؛ آپشن‌ها و تریم داخلی خودرو در زمان تحویل ممکن است با اطلاعات مندرج در کاتالوگ و سایت مغایرت داشته باشد.
            </div>
            <div className="buttons">
              <Button title="مرحله قبل" onClick={prev} />
              <Button title="تایید و ادامه" onClick={next} />
            </div>
          </section>
        </Col>
      </Row>
    </DetialComponent>
  );
};
export default Detial;
